import { Heading } from "./heading";
import { Actions } from "./actions";
import { Video } from "./video";

export const Hero = () => {
  return (
    <div
      css={`
        padding: 36px 20px;
        background: black;

        @media (min-width: 960px) {
          padding: 90px 20px;
        }
      `}
    >
      <div
        css={`
          max-width: 1250px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 25px;

          @media (min-width: 960px) {
            flex-direction: row;
            gap: 60px;
          }
        `}
      >
        <div
          css={`
            @media (min-width: 960px) {
              flex: 1.1;
            }
          `}
        >
          <Heading />
          <Actions />
        </div>

        <div
          css={`
            @media (min-width: 960px) {
              flex: 1;
            }
          `}
        >
          <Video />
        </div>
      </div>
    </div>
  );
};
